import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useStyles } from './styles'
import Box from '@material-ui/core/Box'
import Chip from '@material-ui/core/Chip'
import clsx from 'clsx'
import ConfirmationNumberOutlinedIcon from 'components/material-symbol/icons/ConfirmationNumber'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import differenceInDays from 'date-fns/differenceInDays'
import pluralize from 'lib/pluralize'
import RedeemIcon from 'components/material-symbol/icons/Redeem'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from 'components/material-symbol/icons/MoreVert'
import LessonPackCardActions from './lesson-pack-card-actions'

const LessonPackCard = ({
  expiresAt,
  totalCredits,
  remainingCredits,
  lessonCredits,
  lessonType,
  isUsedOrExpired,
  id: lessonPackId,
  onGiftClick,
}) => {
  const { title, coach, giftingEnabled } = lessonType
  const isGiftable = giftingEnabled && totalCredits === remainingCredits
  const { name } = coach

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleMenuClick = event => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const daysToExpire = differenceInDays(parseISO(expiresAt), new Date())
  const showExpireWarning = daysToExpire > 0 && daysToExpire < 30

  const classes = useStyles()

  const formattedExpirationDate = expDate => {
    return format(parseISO(expDate), 'MMMM d, yyyy')
  }

  const formattedLastUpdatedAtDate = lastUpdAt => {
    if (!lastUpdAt) return null
    return format(lastUpdAt, 'MMMM d, yyyy')
  }

  const defineLastUpdatedDate = credits => {
    return Math.max(...credits.map(item => new Date(item.updatedAt)))
  }

  let lastUpdatedAt
  if (isUsedOrExpired) {
    lastUpdatedAt = formattedLastUpdatedAtDate(
      defineLastUpdatedDate(lessonCredits),
    )
  }

  return (
    <Box className={classes.bookingType}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" mb={1} style={{ width: '100%' }}>
          <Avatar className={classes.iconStyled}>
            <ConfirmationNumberOutlinedIcon
              color={isUsedOrExpired ? 'disabled' : 'primary'}
            />
          </Avatar>
          {!isUsedOrExpired && (
            <Box display="flex" style={{ marginLeft: 'auto' }}>
              {showExpireWarning && (
                <Chip
                  className={clsx(classes.chip, classes.chipWarning)}
                  label="Expires Soon"
                />
              )}
              {isGiftable && (
                <Chip
                  className={clsx(
                    classes.chipGiftable,
                    classes.chipGiftableText,
                  )}
                  icon={<RedeemIcon className={classes.chipGiftableIcon} />}
                  label="Giftable"
                />
              )}
              <Chip
                className={clsx(classes.chip, classes.chipInfo)}
                label={`${remainingCredits} ${pluralize(
                  remainingCredits,
                  'lesson',
                )} left`}
              />
              {isGiftable && (
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={handleMenuClick}
                  size="small"
                  className={classes.moreMenu}
                >
                  <MoreVertIcon />
                </IconButton>
              )}
            </Box>
          )}
          {!remainingCredits && (
            <Box display="flex" style={{ marginLeft: 'auto' }}>
              <Chip
                className={clsx(classes.chip, classes.chipInfo)}
                label="Used"
              />
            </Box>
          )}
        </Box>
      </Box>
      <Typography variant="body1" gutterBottom>
        {title}
      </Typography>
      <Box mb={2}>
        <Typography
          variant="caption"
          className={`${classes.captionText} ${classes.lighterText}`}
        >
          {name}
        </Typography>
        <br />
        {isUsedOrExpired && (
          <>
            <Typography
              variant="caption"
              className={`${classes.captionText} ${classes.lighterText}`}
            >
              {totalCredits} {pluralize(totalCredits, 'lesson')}
            </Typography>
            <br />
            <Typography
              variant="caption"
              className={`${classes.captionText} ${classes.lighterText}`}
            >
              Last used: {lastUpdatedAt}
            </Typography>
            <br />
          </>
        )}
        {expiresAt && (
          <Typography
            variant="caption"
            className={`${classes.captionText} ${classes.lighterText}`}
          >
            Expires: {formattedExpirationDate(expiresAt)}
          </Typography>
        )}
      </Box>
      {!isUsedOrExpired && (
        <LessonPackCardActions
          isGiftable={isGiftable}
          onGiftClick={onGiftClick}
          lessonType={lessonType}
          remainingCredits={remainingCredits}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          lessonPackId={lessonPackId}
        />
      )}
    </Box>
  )
}

export default LessonPackCard
